<template>
    <div>
        <CDataTable
            class="reports"
            hover
            :items="list"
            :fields="fields">
            <template #title="data">
                <td>{{ cutTitle(data.item.title) }}</td>
            </template>
            <template #created_at="data">
                <td>{{ formatDate(data.item.created_at) }}</td>
            </template>
            <template #status="data">
                <td style="width: 200px;">
                    <CProgress
                        :value="data.item.status"
                        color="success"
                        class="mt-1"
                        :show-value="true"
                        :show-percentage="true"
                    />
                </td>
            </template>
            <template #download="data">
                <td>
                    <CButton
                        color="info"
                        size="sm"
                        class="m-0"
                        :disabled="data.item.status !== 100"
                        @click="$emit('download', data.item.title)"
                    >Скачать</CButton>
                </td>
            </template>
            <template #delete="data">
                <td>
                    <CButton
                        color="danger"
                        size="sm"
                        class="m-0"
                        :disabled="data.item.status !== 100"
                        @click="$emit('deleteFile', data.item.title)"
                    >Удалить</CButton>
                </td>
            </template>
        </CDataTable>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {

        props: {
            list: {
                type: Array,
                default: () => [],
            },
        },

        data() {
            return {
                isAuthorized: false,
                fields: [
                    { key: 'title', label: 'Название' },
                    { key: 'created_at', label: 'Дата создания' },
                    { key: 'status', label: 'Статус' },
                    { key: 'download', label: 'Скачать' },
                    { key: 'delete', label: 'Удалить' },
                ],
            };
        },

        computed: {
        },

        async created() {
        },

        methods: {
            formatDate(date) {
                return moment(date).format('YYYY-MM-DD HH:mm');
            },
            cutTitle(title) {
                return title.substr(20, title.length);
            }
        },
    };
</script>

<style scoped>
.status-cell span {
    display: block;
}
.reports table td,
.reports table th {
    white-space: nowrap;
}
</style>
